import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import {
  faCreditCard,
  faExclamationCircle,
  faFile,
  faFolder,
  faQuestionCircle,
  faTag
} from "@fortawesome/pro-regular-svg-icons"
import { faAngleDown, faAngleUp, faWrench } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Accordion, AccordionContent, AccordionTitle, Divider, Label } from "semantic-ui-react"
import checkTick from "../../../images/check-tick.svg"
import needHelpInfoIcon from "../../../images/need-help-info-icon.svg"

import { isEbayTireOrder } from "../../../v1/helpers/orderHelpers"
import { getTireShopOrderDetails } from "../../../v1/actions/bookingConfirmation"
import { getSubdomain } from "../../../v1/components/Config/StylesheetInjector"
import { isEbay } from "../../../v1/helpers/affiliationHelpers"

const ViewShopInstructions = ({
  vehicle,
  user,
  history,
  getTireShopOrderDetails,
  orders,
  match
}) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [tireOrder, setTireOrder] = React.useState(null)
  const { orderId } = match?.params
  const order = orders?.find((order) => order.id === Number(orderId))

  const handleTitleClick = (e, titleProps) => {
    const { index } = titleProps
    const newIndex = activeIndex === index ? -1 : index
    setActiveIndex(newIndex)
  }

  const orderServices = order?.order_services?.map((service) => {
    return (
      <div className="vsi-services-list-div">
        <p className="vsi-services-list">&bull; {service?.name}</p>
        <p className="vsi-services-list">
          {!isEbayTireOrder(order) && service?.override_total_with_promotional_discount === 0
            ? "Priced at shop"
            : `$${Number(service?.override_total_with_promotional_discount).toFixed(2)}`}
        </p>
      </div>
    )
  })

  let vehicleDetails = ""
  if (vehicle?.year > 0) {
    vehicleDetails += vehicle?.year + " "
  }
  if (vehicle?.make !== null) {
    vehicleDetails += vehicle?.make + " "
  }
  if (vehicle?.model !== null) {
    vehicleDetails += vehicle?.model
  }

  useEffect(() => {
    async function fetchTireOrder() {
      if (order?.is_tire_order && order?.id) {
        const res = await getTireShopOrderDetails(user, order.id - 1)
        if (res.result) {
          setTireOrder(res.result.tire_shop_order)
        }
      }
    }

    fetchTireOrder()
  }, [order])
  const tire = tireOrder?.tire_orders?.[0]

  if (!order) {
    return <div className="view-shop-instructions-container"></div>
  }
  return (
    <div className="view-shop-instructions-container">
      <div className="container-header">
        <div className="container-header-1">
          <FontAwesomeIcon icon={faArrowLeft} size="16px" onClick={() => history.goBack()} />
          <div className="container-header-title">
            <p className="service-header">CarAdvise Fleet Service</p>
          </div>
          <FontAwesomeIcon icon={faArrowLeft} size="16px" style={{ opacity: "0" }} />
        </div>
        <div className="container-header-2">
          <img src={checkTick} alt="Check Tick" />
          <p className="service-check-in-header">Check in as a CarAdvise Fleet customer</p>
        </div>
      </div>
      <div className="view-shop-instructions-accordion-container-black">
        <p className="service-instructions-header">Show this screen at check in</p>
        <div className="check-in-div">
          <p className="service-process">Process work order via AutoIntegrate</p>
          {order.shop.company_national_account_number &&
            order.shop.company_national_account_number?.toString().trim() !== "" && (
              <p className="account-number">
                Fleet Account Number:
                <br />
                <b>{order.shop.company_national_account_number}</b>
              </p>
            )}
        </div>
        {isEbay() && (
          <div className="check-in-div">
            {order.shop.company_national_account_number !== "" && (
              <p className="ebay-order-id">
                eBay order ID:
                <br />
                <b>{order.third_party_id}</b>
              </p>
            )}
          </div>
        )}
        <div className="check-in-steps-div">
          <p className="check-in-next">Next steps:</p>
          <div className="check-in-step-1">
            <div className="round-circle">
              <p>1</p>
            </div>
            <p className="check-in-step-title">Approval: </p>
            <p className="check-in-step-content">Await Customer app approval</p>
          </div>
          <div className="check-in-step-2">
            <div className="round-circle">
              <p>2</p>
            </div>
            <p className="check-in-step-title">Payment: </p>
            <p className="check-in-step-content">Do not bill customer directly</p>
          </div>
          <div className="check-in-step-3">
            <div className="round-circle">
              <p>3</p>
            </div>
            <p className="check-in-step-title">Discount: </p>
            <p className="check-in-step-content">CarAdvise applies savings automatically</p>
          </div>
        </div>
      </div>
      <div className="view-shop-instructions-accordion-container">
        <Accordion className="view-shop-instructions-accordion">
          <AccordionTitle
            active={activeIndex === 1}
            index={1}
            onClick={handleTitleClick}
            className="view-shop-instructions-accordion-title"
          >
            <div className="vsi-accordion-title-text-container">
              <div>
                <FontAwesomeIcon icon={faWrench} style={{ paddingRight: "10px" }} color="#E95832" />
                <b>Service Details</b>
              </div>
              <FontAwesomeIcon icon={activeIndex === 1 ? faAngleUp : faAngleDown} />
            </div>
          </AccordionTitle>
          <AccordionContent active={activeIndex === 1}>
            <div className="vsi-accordion-content">
              <p className="vsi-accordion-content-text">
                <b>Customer:</b> {user?.firstName} {user?.lastName}
              </p>
              <p className="vsi-accordion-content-text">
                <b>Vehicle:</b> {vehicleDetails}
              </p>
              {isEbayTireOrder(order) && (
                <>
                  {order?.tire_details && (
                    <p className="vsi-accordion-content-text">
                      <p style={{ margin: 0, lineHeight: "30px" }}>
                        <b>Tires from eBay:</b> {order?.tire_details}
                      </p>
                    </p>
                  )}
                </>
              )}
              {order?.is_tire_order && tireOrder && tire && (
                <p className="vsi-accordion-content-text">
                  <b>Tires:</b> {tire?.quantity} {tire?.brand} {tire?.tire_model}{" "}
                  {tire?.tire_details}
                </p>
              )}
              <b style={{ lineHeight: "25px" }}>Requested services:</b>
              {orderServices}
              <Divider />
              <div className="vsi-estimated-div">
                <b>Estimated subtotal:</b>
                <b>
                  {!isEbayTireOrder(order) && order?.estimated_sub_total === 0
                    ? "Priced at shop"
                    : `$${Number(order.estimated_total).toFixed(2)}`}
                </b>
              </div>
            </div>
          </AccordionContent>
        </Accordion>
        <div className="vsi-accordion-title-text-container-notes">
          <img src={needHelpInfoIcon} alt="Help info" style={{ marginTop: "10px" }} />
          <p className="instructions-notes">
            <b>Note:</b> The shop’s paperwork may show a different price. This is normal. Your
            official receipt is in the app.
          </p>
        </div>
      </div>

      <div className="vsi-help-text">
        <FontAwesomeIcon
          icon={faQuestionCircle}
          style={{ paddingRight: "5px", paddingTop: "2px" }}
        />
        <p style={{ margin: 0 }}>
          Problem at the shop? We're here to help : Call <b>(844) 923-8473.</b>
        </p>
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  const user = state.user
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)

  return {
    vehicle: activeVehicle,
    user: user,
    orders: user.active_orders
  }
}

export default connect(mapStateToProps, {
  getTireShopOrderDetails
})(ViewShopInstructions)
